import styled from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';
import {CustomIcon} from '@guestapp/old-ui-kit';

export const EmptyBox = styled.div`
  display: flex;
  min-height: 80px;
  cursor: pointer;
  padding: 16px;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background-color: ${({theme}) =>
    theme.hasTemplate ? theme.colors.branding.backgroundSecondary : '#eaecef'};

  &:hover {
    background-color: rgba(56, 91, 248, 0.1);
    transition: background-color 0.05s ease-in-out;
  }

  @media (min-width: ${DEVICE.laptop}) {
    width: 100%;
  }

  @media (min-width: ${DEVICE.laptopM}) {
    max-width: 416px;
  }
`;

export const EmptyBoxTitle = styled.div`
  color: ${({theme}) =>
    theme.hasTemplate ? theme.colors.branding.fontSecondary : '#777e91'};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

export const ButtonBox = styled(CustomIcon).attrs({className: 'guests-panel__add-btn'})`
  path {
    stroke: ${({theme}) =>
      theme.hasTemplate ? theme.colors.branding.boxesModals : '#fff'};
  }
`;
